import keycloak from '@/auth/keycloak';
import { Button } from '@/components/custom/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useUserProfile } from '@/auth/user-info';
import { Role } from '@/auth/constants';
import { useEffect, useState } from 'react';
import { NavigationFixUtility } from '@/utils/navigation-fix';

export default function UnauthorisedError() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const userProfile = useUserProfile();
  const [safeRedirectPath, setSafeRedirectPath] = useState('/');

  // Determine a safe place to redirect the user based on their roles
  useEffect(() => {
    if (!userProfile || !userProfile.roles) {
      return;
    }

    const roles = userProfile.roles || [];
    
    // Determine best redirect location based on user roles
    if (roles.includes(Role.Admin)) {
      setSafeRedirectPath('/');
    } else if (roles.includes(Role.Finance)) {
      setSafeRedirectPath('/finances/invoices');
    } else if (roles.includes(Role.Teacher) || roles.includes(Role.Supervisor)) {
      setSafeRedirectPath('/children/groups');
    } else {
      // Default fallback
      setSafeRedirectPath('/children/sign-in');
    }
  }, [userProfile]);

  const goToSafePage = () => {
    // Use replace instead of push to avoid keeping the 401 page in history
    navigate(safeRedirectPath, { replace: true });
  };

  return (
    <>
      <NavigationFixUtility />
      <div className="h-svh w-full">
        <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-2">
          <h1 className="text-[7rem] font-bold leading-tight">
            {t('errors.401.title')}
          </h1>
          <span className="font-medium text-xl">
            {t('errors.401.message')}
          </span>
          <p className="text-center text-muted-foreground text-xs">
            {t('errors.401.description')}
          </p>
          <div className="mt-6 flex gap-4">
            <Button
              variant="outline"
              onClick={goToSafePage}>
              {t('errors.401.return_home')}
            </Button>
            <Button
              onClick={() =>
                keycloak.logout({
                  redirectUri: window.location.origin,
                })
              }>
              {t('errors.401.logout')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
